import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// the translations
// (tip move them in a JSON file and import them)
var resources = {
    en: {
        translation: {
            emailPlaceHolder: "Enter your email",
            emailRequired: "Email is a required field",
            headerText: "Welcome to React, react-i18next, Yup and Formik",
            reset: "reset",
            submit: "submit",
        },
    },
    fr: {
        translation: {
            birthday: "Date de naissance",
            college: "Collège",
            date: "une date",
            dateMax: "La date doit être passée",
            diploma: "Diplôme",
            domain: "domain",
            emailPlaceHolder: "Fournissez votre email",
            emailRequired: "Email est un champ requis",
            firstName: "Prénom",
            gender: "Genre",
            headerText: "Bienvenue a React and react-i18next, Yup et Formik",
            lastName: "Nom",
            level: "Niveau d'étude",
            lycee: "Lycée",
            postalCode: "Code postal",
            reset: "réinitialiser",
            speciality: 'Spécialités',
            status: "statut",
            submit: "soumettre",
            userName: "Pseudo",
        },
    },
};
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    interpolation: {
        escapeValue: false,
    },
    keySeparator: false,
    lng: "fr",
    resources: resources,
});
export default i18n;
//# sourceMappingURL=i18next.js.map